import { useEffect } from 'react';
import { formatPhoneNumber, type CallableLine } from '@avslack/shared';
import { lastUsedLine } from '../data/phone';

/**
 * HIVOSZAM-VALASZTO: melyik vonalrol (szamrol) hivunk.
 *
 * Csak akkor latszik, ha tobb vonalrol is hivhatunk. Az alapertelmezes: a
 * csatorna vonala (a telefonos csatornabol tarcsazunk), kulonben az, amelyikrol
 * legutobb hivtunk, kulonben az elso.
 */
export function defaultLineId(lines: CallableLine[], channelId?: string | null): string | null {
  if (lines.length === 0) return null;
  const byChannel = channelId ? lines.find((line) => line.channelId === channelId) : undefined;
  if (byChannel) return byChannel.id;
  const last = lastUsedLine();
  return lines.find((line) => line.id === last)?.id ?? lines[0]!.id;
}

export function LinePicker({
  lines,
  value,
  onChange,
  channelId,
}: {
  lines: CallableLine[];
  value: string | null;
  onChange: (lineId: string) => void;
  channelId?: string | null;
}) {
  // Az elso betolteskor (vagy ha a kivalasztott eltunt) az alapertelmezes.
  useEffect(() => {
    if (value && lines.some((line) => line.id === value)) return;
    const next = defaultLineId(lines, channelId);
    if (next) onChange(next);
  }, [lines, value, channelId, onChange]);

  if (lines.length < 2) return null;

  return (
    <label className="flex items-center gap-1.5 text-xs text-ink-muted">
      Hívószám:
      <select
        value={value ?? ''}
        onChange={(event) => onChange(event.target.value)}
        className="min-w-0 rounded-control border border-border bg-surface px-2 py-1 text-xs text-ink"
      >
        {lines.map((line) => (
          <option key={line.id} value={line.id}>
            {line.label} · {formatPhoneNumber(line.number)}
          </option>
        ))}
      </select>
    </label>
  );
}
